import { createSignal } from "solid-js";
import { createStore, reconcile } from "solid-js/store";

import { GetUnreadMsg, ReadAllMsg, ReadMsg } from "@/api/clientApi/notice.ts";
import { useI18n } from "@/i18n";
import { ClickType } from "@/types/compontent/base/baseEnum.ts";
import { MsgInfo } from "@/types/swagger/notice.ts";

interface TabState {
  title: string;
  count: number;
  index: number;
  list: MsgInfo[];
}

const { t } = useI18n();

type PageData = {
  tabIndex: number;
};

const initialStore = {
  tabList: [
    {
      title: t("notice.platform"),
      count: 0,
      index: 0,
      list: [],
    },
    {
      title: t("notice.personal"),
      count: 0,
      index: 1,
      list: [],
    },
  ] as TabState[],
  pageData: {
    tabIndex: 0,
  } as PageData,

  count: 0,
};
export const [notificationStore, setNotificationStore] =
  createStore(initialStore);
export const useNotification = () => {
  const [finish, setFinish] = createSignal(false);

  const changeTabIndex = (index: number) => {
    setNotificationStore("pageData", (prev) => ({
      ...prev,
      tabIndex: index,
    }));
  };

  const initNotification = () => {
    GetUnreadMsg({ msg_type: 0 }).then((res) => {
      setFinish(true);
      const list = [
        {
          title: t("notice.platform"),
          count: res?.unread?.[1] || 0,
          index: 0,
          // @ts-expect-error temp
          list: res?.msg_list?.[1] || [],
        },
        {
          title: t("notice.personal"),
          count: res?.unread?.[2] || 0,
          index: 1,
          // @ts-expect-error temp
          list: res?.msg_list?.[2] || [],
        },
      ];
      const count = (res?.unread?.[1] || 0) + (res?.unread?.[2] || 0);
      setNotificationStore("count", count);
      setNotificationStore("tabList", reconcile(list));
    });
  };

  const readMsgCallback = (params: { id: number; msg_type: number }) => {
    ReadMsg(params).then(() => {
      initNotification();
    });
  };

  const readAllMsgCallback = (params: {
    ids: number[];
    msg_type: number;
    read_status: number;
  }) => {
    ReadAllMsg(params).then(() => {
      initNotification();
    });
  };

  // 根据点击功能枚举，区分点击处理事件
  const jumpClickCallback = (params: {
    click_id: ClickType;
    click_params: string;
    click: (click_id: ClickType, click_params: string) => void;
  }) => {
    params.click(params.click_id, params.click_params);
  };

  return {
    tabList: notificationStore.tabList,
    pageData: notificationStore.pageData,
    count: notificationStore.count,
    finish,
    initNotification,
    changeTabIndex,
    readMsgCallback,
    readAllMsgCallback,
    jumpClickCallback,
  };
};
